import React from 'react';

const RefreshImg = (props) => {
  const { func } = props;

  return (
    <button type="button" className="refresh-img" onClick={() => func()} />
  );
};

export default RefreshImg;
